// extracted by mini-css-extract-plugin
export default {"logoContainer":"logo-styles__logoContainer","letter":"logo-styles__letter","topLine":"logo-styles__topLine","bottomLine":"logo-styles__bottomLine"};